import axios, { AxiosResponse } from "axios";
import { TableData } from "../../models/dtos/base/TableData";
import { PrizesReceivedDTO } from "../../models/dtos/management/PrizesReceivedDTO";
import { RewardDTO } from "../../models/dtos/management/RewardDTO";
import { QueryPagesDTO } from "../../models/query-strings/base/QueryPagesDTO";
import BaseService from "../base/BaseService";

export default class RewardService extends BaseService {
    getPages(queryInfo: QueryPagesDTO): Promise<TableData<RewardDTO>> {
        return axios.get(`/Rewards`, { params: queryInfo })
            .then(function (response: AxiosResponse<TableData<RewardDTO>, any>) {
                return response.data;
            });
    }

    getMyRewards(queryInfo: QueryPagesDTO): Promise<TableData<PrizesReceivedDTO>> {
        return axios.get(`/Rewards/GetMyRewards`, { params: queryInfo })
            .then(function (response: AxiosResponse<TableData<PrizesReceivedDTO>, any>) {
                return response.data;
            });
    }

    useReward(rewardId: number): Promise<any> {
        return axios.post(`/Rewards/${rewardId}`)
            .then(function (response: AxiosResponse<any, any>) {
                return response;
            });
    }
}